module.exports = __webpack_public_path__ + "img/佐々木愛里.74a9a049.jpg";